<template>
  <TiptapText
    :id="id"
    :text="data"
    :editable="false"
    :locale="locale"
    :preview="preview"
    placeholder="כתבו כאן את הטקסט"
    class="non-editable"
    :keyboardSettings="keyboardSettings"
    :extensions="extensions"
  ></TiptapText>
</template>
<script setup lang="ts">
import TiptapText from './TiptapText.vue';
import { PropType } from 'vue';
import { KeyboardSettings } from '@amit/types/src/blocks/blocks.ts';

defineProps({
  id: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: 'my answer',
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  locale: {
    type: String,
    default: 'he',
  },
  preview: {
    type: Boolean,
    default: true,
  },
  keyboardSettings: {
    type: Object as PropType<KeyboardSettings>,
    default: () => ({}),
  },
  extensions: {
    type: Object,
    default: () => ({
      bank_view: false,
    }),
  },
});
</script>
<style scoped>
.non-editable .editor-content {
  @apply p-0;
}
.tiptap-placeholder[contenteditable='false'] {
  visibility: hidden;
}
</style>
